var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawtoolsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.27,6.24c-.11-.27-.24-.54-.37-.8a3.07,3.07,0,0,0-4.25-4.29,8.93,8.93,0,0,0-.83-.39,10,10,0,0,0-13.08,13c.12.29.28.56.43.84a3,3,0,0,0-.46.86,3.08,3.08,0,0,0,3.84,3.87h0a3.22,3.22,0,0,0,.88-.46,7.59,7.59,0,0,0,.77.35,10,10,0,0,0,13.06-13ZM17.4,3.59a1,1,0,0,1-1.22,1.09,1,1,0,0,1,.3-2A1,1,0,0,1,17.1,3,1.06,1.06,0,0,1,17.4,3.59ZM2.93,17.13a1,1,0,0,1,.82-1.73,1,1,0,0,1,.62.29,1,1,0,0,1,0,1.44,1,1,0,0,1-1.44,0Zm12.69-1.51a7.93,7.93,0,0,1-8.27,1.87,6.59,6.59,0,0,1-.73-.3,3.06,3.06,0,0,0-3.78-3.74A8,8,0,0,1,12.68,2.51c.26.1.51.2.75.32A3.06,3.06,0,0,0,17.2,6.64a6.59,6.59,0,0,1,.3.73h0A8,8,0,0,1,15.62,15.62Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawtoolsCircle);
export default __webpack_public_path__ + "static/media/drawtools_circle.98553364d2f92f1f09169ff046d1fb96.svg";
export { ForwardRef as ReactComponent };